import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CalendarViewMonthOutlinedIcon from "@mui/icons-material/CalendarViewMonthOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import FilterNoneOutlinedIcon from "@mui/icons-material/FilterNoneOutlined";
import { useStoreDispatch } from "../../store/Hooks";
import useHttp from "../../hooks/useHttp";
import { useState } from "react";
import { interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";
import Interaction from "../../models/interactions/Interaction";
import { navSliceActions } from "../../store/slices/NavSlice";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import IntervalSet from "../../models/communications/IntervalSet";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import InteractionSettings from "../../models/config/InteractionSettings";
import Interval from "../../models/communications/Interval";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import InteractionNode from "../../models/interactions/InteractionNode";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { runDatabaseFunction } from "../../helpers/HttpHelper";

// BLUE + BUTTON FOR CLICKING AND ADDING CHILDREN TO CURRENT PARENT
// FOR MVP WILL INCLUDE PATHWAYS, EVENTS, AND INTERVAL SETS
// POST MVP WE WILL ADD QUESTIONS, SURVEYS, ANSWERS, ETC
// NEW NODES ARE ADDED AS IMMEDIATE CHIREN

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
  },
  list: {
    marginTop: 20,
    padding: "0 60px",
    marginBottom: 40,
  },
  title: {
    fontSize: "2em",
    fontWeight: "bold",
    padding: "15px 0",
  },
  icon: {
    color: "#1976d2",
  },
  main: {
    color: "white",
    backgroundColor: "#2E7D32",
  },
});

interface AddChildInteractionButtonProps {
  setID: number | null;
  parentID: number | null;
  type: string; // e.g. "pathway" || "cs1survey" || "question" || "answer" ...etc
  // eslint-disable-next-line @typescript-eslint/ban-types
  handler?: Function | null; // function that will be called from child into parent to make something propietary happen
  main: boolean;
  numChildren: number;
  ordinal?: number;
  associatedIntervalIDs?: Array<number>;
  intervalSetID: number | null;
  accounts?: boolean;
  demo?:boolean;
  shared?:boolean;
}

const AddChildInteractionButton = (props: AddChildInteractionButtonProps) => {
  const dispatch = useStoreDispatch();
  const { sendRequest: fetchData } = useHttp();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const shared  = typeof props.shared !== "undefined" ? props.shared : false; 

  // add a new interaction and node for the interaction
  const handleAddNewInteraction = async (
    setID: number | null,
    parentID: number | null,
    type: string
  ) => {
    setID = shared ? parentID : setID;
    console.log(setID)
    const newInteraction = await Interaction.addNewInteraction(
      setID,
      parentID,
      type,
      props.ordinal || 1,
      true)

    if (props.handler) {
      props.handler(newInteraction.id);
    }

    // if inserting brand new top-level pathway from top-level green button,
    // immediately navigate to that newly-generated set context
    if (type === "account") {
      navigate("contents/s" + newInteraction.id);
    }
  };

  const handleSelectExistingInteraction = (type: string) => {
    let intervalSetID: number | null = null;
    if (type == "cs1survey") {
      intervalSetID = props.intervalSetID;
    }
    if (intervalSetID) {
      dispatch(
        navSliceActions.openModal({
          thisSet: props.setID,
          thisParent: props.parentID,
          type: type,
          intervalSetID: intervalSetID,
          ordinal: props.ordinal,
        }),
      );
    } else {
      dispatch(
        navSliceActions.openModal({
          thisSet: props.setID,
          thisParent: props.parentID,
          type: type,
          ordinal: props.ordinal,
        }),
      );
    }
    handleClose();
  };

  const handleAddNewIntervalSet = async (
    currentSetID: number,
    currentParentID: number,
  ) => {
    currentSetID = shared ? currentParentID : currentSetID;
    await Interaction.addInteractionToTree(currentSetID, currentParentID, "interval_set", props.ordinal)
  };

  const handleSelectExisting = (type: string) => {
    let intervalSetID: number | null = null;
    if (type == "cs1survey") {
      intervalSetID = props.intervalSetID;
    }
    dispatch(
      navSliceActions.openModal({
        thisSet: props.setID,
        thisParent: props.parentID,
        type: type,
        intervalSetID: intervalSetID,
      }),
    );
  };

  const classes = useStyles();

  // dropdown controls
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    console.log("Current Parent: " + props.parentID)
    console.log("Current Set: " + props.setID)
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  let mainButtonStyle = {};
  let buttonStyling = {};

  if (props.type === "main") {
    mainButtonStyle = {
      color: "white",
      fontWeight: "bold",
      backgroundColor: "#00cc66",
      border: "3pt solid #00cc66",
      padding: "13px",
    };
  } else if (props.type === "intervalSet") {
    mainButtonStyle = {
      // color: "white",
      padding: "15px",
      // backgroundColor: "#1976d2",
      margin: "0px 20px 20px auto",
      border: "2px solid #1976d2",
    };
  } else if (props.type === "insert") {
    mainButtonStyle = {
      float: "right",
      color: "white",
      backgroundColor: "#1976d2",
      margin: "0px 20px 20px auto",
      padding: "0px",
      zIndex: 1000,

    };
  } else if (props.type == "insertIntervalSetInteraction") {
    mainButtonStyle = {
      // float: "right",
      color: "white",
      backgroundColor: "#1976d2",
      height: "15px",
      width: "15px",
      position: "absolute",
      top: "-5px",
      left: "7px",
      zIndex: 400,
      // #3eed78
      // #1976d2
      // margin: "0px 20px 20px auto",
      padding: "0px",
    };

    buttonStyling = { fontSize: "4pt" };
  } else {
    mainButtonStyle = {
      float: props.demo ? "none" : "right",
      color: "white",
      backgroundColor: "#1976d2",
      margin: "0px 20px 20px auto",
      zIndex: 1000,

    };
  }

  if (
    props.type === "pathway" ||
    props.type === "main" ||
    props.type === "insert"
  ) {
    return (
      <div>
        <IconButton
          data-testid={"interactionAddButton" + props.parentID}
          style={mainButtonStyle}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <AddIcon sx={buttonStyling} />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuList style={{ color: "#1976d2" }}>
            {/* {props.type !== "main" && (
              <MenuItem
                data-testid={"addNewEventButton" + props.parentID}
                onClick={() => {
                  handleClose(); // close the dropdown
                  addNewInteraction(props.setID, props.parentID, "cs1survey");
                }}
              >
                <ListItemIcon>
                  <FilterNoneOutlinedIcon
                    fontSize="small"
                    className={classes.icon}
                  />
                </ListItemIcon>
                <ListItemText>Add New Event</ListItemText>
              </MenuItem>
            )} */}
            {/* {props.type !== "main" && (
              <MenuItem
                data-testid={"addExistingEventButton" + props.parentID}
              >
                <ListItemIcon>
                  <FolderOpenOutlinedIcon
                    fontSize="small"
                    className={classes.icon}
                  />
                </ListItemIcon>
                <ListItemText
                  onClick={() => {
                    handleSelectExistingInteraction("cs1survey");
                  }}
                >
                  Add Existing Event
                </ListItemText>
              </MenuItem>
            )} */}
            {props.type !== "main" && <Divider />}
            {props.type !== "main" && !props.accounts && (
              <MenuItem
                data-testid={"addNewIntervalSetButton" + props.parentID}
                onClick={() => {
                  handleClose(); // close the dropdown
                  if (props.setID && props.parentID) {
                    handleAddNewIntervalSet(props.setID, props.parentID);
                  }

                }}
              >
                <ListItemIcon>
                  <CalendarViewMonthOutlinedIcon
                    fontSize="small"
                    className={classes.icon}
                  />
                </ListItemIcon>
                <ListItemText>Add New Interval Set</ListItemText>
              </MenuItem>
            )}
            {props.type !== "main" && !props.accounts && (
              <MenuItem
                data-testid={"addExistingIntervalSetButton" + props.parentID}
              >
                <ListItemIcon>
                  <FolderOpenOutlinedIcon
                    fontSize="small"
                    className={classes.icon}
                  />
                </ListItemIcon>
                <ListItemText
                  onClick={() => {
                    handleSelectExistingInteraction("intervalset");
                  }}
                >
                  Add Existing Interval Set
                </ListItemText>
              </MenuItem>
            )}
            {props.type !== "main" && <Divider />}

            <MenuItem
              data-testid={"addNewPathwayButton" + props.parentID}
              onClick={async () => {
                handleClose(); // close the dropdown
                await handleAddNewInteraction(props.setID, props.parentID, "pathway");
              }}
            >
              <ListItemIcon>
                <TableRowsOutlinedIcon
                  fontSize="small"
                  className={classes.icon}
                />
              </ListItemIcon>
              <ListItemText>Add New Pathway</ListItemText>
            </MenuItem>
            {props.type !== "main" && (
              <MenuItem
                data-testid={"addExistingPathwayButton" + props.parentID}
              >
                <ListItemIcon>
                  <FolderOpenOutlinedIcon
                    fontSize="small"
                    className={classes.icon}
                  />
                </ListItemIcon>
                <ListItemText
                  onClick={() => {
                    handleSelectExistingInteraction("pathway");
                  }}
                >
                  {" "}
                  Add Existing Pathway
                </ListItemText>
              </MenuItem>
            )}
          </MenuList>
        </Menu>
      </div>
    );
  } else if (props.type === "insertIntervalSetInteraction") {
    return (
      <div>
        <IconButton
          data-testid={"interactionAddButton" + props.parentID}
          style={mainButtonStyle}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={() => {
            handleClose(); // close the dropdown
            const newPlaceholderInteraction = {
              id: -1,
              title: "Enter New Title",
              properties: new InteractionSettings("cs1survey"),
              modified: new Date()
            } as Interaction; // TODO - dont hardcode properties

            const newPlaceholderInteractionNode = {
              id: -1,
              set_interaction_id: props.setID as number,
              parent_interaction_id: props.parentID as number,
              ordinal: props.ordinal ? props.ordinal + 1 : 1,
              child_interaction_id: -1,
              condition_id: null,
              modified: new Date(),
            } as InteractionNode;

            // for v1/cs1surveys, we want to open drawer and v1 editor iframe
            // when they select a survey in v1, PHP will handle the creation
            // of the intervalSet row interaction
            dispatch(
              navSliceActions.openRightDrawer({
                content: newPlaceholderInteraction,
                type: "interactions",
                extraData: { interactionNode: newPlaceholderInteractionNode, associatedIntervals: props.associatedIntervalIDs?.join(",") }
              }),
            );
          }}
        >
          <AddIcon />
        </IconButton>
        {/* <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuList style={{ color: "#1976d2" }}>
            <MenuItem
              data-testid={"addNewEventButton" + props.parentID}
              onClick={() => {
                handleClose(); // close the dropdown
                if (props.handler) {
                  props.handler(
                    props.associatedIntervalIDs,
                    "Enter Title",
                    new InteractionSettings("cs1survey"),
                    props.ordinal ? props.ordinal : 0,
                    null,
                    "",
                    props.parentID,
                    props.setID,
                  );
                }
              }}
            >
              <ListItemIcon>
                <FilterNoneOutlinedIcon
                  fontSize="small"
                  className={classes.icon}
                />
              </ListItemIcon>
              <ListItemText>Add New Deliverable</ListItemText>
            </MenuItem> */}
        {/* <MenuItem data-testid={"addExistingEventButton" + props.parentID}>
              <ListItemIcon>
                <FolderOpenOutlinedIcon
                  fontSize="small"
                  className={classes.icon}
                />
              </ListItemIcon>
              <ListItemText
                onClick={() => {
                  handleSelectExistingInteraction("cs1survey");
                }}
              >
                Add Existing Deliverable
              </ListItemText>
            </MenuItem> */}
        {/* </MenuList>
        </Menu> */}
      </div>
    );
  } else if (props.type == "accounts") {
    return (
      <Tooltip title = {t('new_account_button_label')}>
        <IconButton
          data-testid={"interactionAddButton" + props.parentID}
          style={mainButtonStyle}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={()=>{
            handleAddNewInteraction(props.setID, props.parentID, "account");
          }}
        >
          <AddIcon />
        </IconButton>
      </Tooltip>
    );
  } else if (props.type == "account") {
    return (
      // this one isnt really be used right now
      <div>
        <IconButton
          data-testid={"interactionAddButton" + props.parentID}
          style={mainButtonStyle}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <AddIcon />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuList style={{ color: "#1976d2" }}>
            <MenuItem
              data-testid={"addNewPathwayButton" + props.parentID}
              onClick={() => {
                handleClose(); // close the dropdown
                handleAddNewInteraction(props.setID, props.parentID, "pathway");
              }}
            >
              <ListItemIcon>
                <TableRowsOutlinedIcon
                  fontSize="small"
                  className={classes.icon}
                />
              </ListItemIcon>
              <ListItemText>Add New Pathway</ListItemText>
            </MenuItem>
            <MenuItem data-testid={"addExistingPathwayButton" + props.parentID}>
              <ListItemIcon>
                <FolderOpenOutlinedIcon
                  fontSize="small"
                  className={classes.icon}
                />
              </ListItemIcon>
              <ListItemText
                onClick={() => {
                  handleSelectExistingInteraction("pathway");
                }}
              >
                {" "}
                Add Existing Pathway
              </ListItemText>
            </MenuItem>
          </MenuList>
        </Menu>
      </div>
    );
  } else {
    return (
      <div>
        <Button
          data-testid={"interactionAddButton" + props.parentID}
          style={{ width: "150px", minHeight: "50px" }}
          variant="contained"
          color="success"
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <AddIcon /> Start Here
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuList style={{ color: "#1976d2" }}>
            {/* {props.type !== "main" && (
              <MenuItem
                data-testid={"addNewEventButton" + props.parentID}
                onClick={() => {
                  handleClose(); // close the dropdown
                  addNewInteraction(props.setID, props.parentID, "cs1survey");
                }}
              >
                <ListItemIcon>
                  <FilterNoneOutlinedIcon
                    fontSize="small"
                    className={classes.icon}
                  />
                </ListItemIcon>
                <ListItemText>Add New Event</ListItemText>
              </MenuItem>
            )} */}
            {/* {props.type !== "main" && (
              <MenuItem
                data-testid={"addExistingEventButton" + props.parentID}
              >
                <ListItemIcon>
                  <FolderOpenOutlinedIcon
                    fontSize="small"
                    className={classes.icon}
                  />
                </ListItemIcon>
                <ListItemText
                  onClick={() => {
                    handleSelectExistingInteraction("cs1survey");
                  }}
                >
                  Add Existing Event
                </ListItemText>
              </MenuItem>
            )} */}
            {props.type !== "main" && <Divider />}
            <MenuItem
              data-testid={"addNewPathwayButton" + props.parentID}
              onClick={() => {
                handleClose(); // close the dropdown
                handleAddNewInteraction(props.setID, props.parentID, "pathway");
              }}
            >
              <ListItemIcon>
                <TableRowsOutlinedIcon
                  fontSize="small"
                  className={classes.icon}
                />
              </ListItemIcon>
              <ListItemText>Add New Pathway</ListItemText>
            </MenuItem>
            <MenuItem data-testid={"addExistingPathwayButton" + props.parentID}>
              <ListItemIcon>
                <FolderOpenOutlinedIcon
                  fontSize="small"
                  className={classes.icon}
                />
              </ListItemIcon>
              <ListItemText
                onClick={() => {
                  handleSelectExistingInteraction("pathway");
                }}
              >
                {" "}
                Add Existing Pathway
              </ListItemText>
            </MenuItem>
            {props.type !== "main" && <Divider />}

            {props.type !== "main" && !props.accounts && (
              <MenuItem
                data-testid={"addNewIntervalSetButton" + props.parentID}
                onClick={() => {
                  handleClose(); // close the dropdown
                  if (props.setID && props.parentID) {
                    handleAddNewIntervalSet(props.setID, props.parentID);
                  }
                }}
              >
                <ListItemIcon>
                  <CalendarViewMonthOutlinedIcon
                    fontSize="small"
                    className={classes.icon}
                  />
                </ListItemIcon>
                <ListItemText>Add New Interval Set</ListItemText>
              </MenuItem>
            )}
            {props.type !== "main" && !props.accounts && (
              <MenuItem
                data-testid={"addExistingIntervalSetButton" + props.parentID}
              >
                <ListItemIcon>
                  <FolderOpenOutlinedIcon
                    fontSize="small"
                    className={classes.icon}
                  />
                </ListItemIcon>
                <ListItemText
                  onClick={() => {
                    handleSelectExistingInteraction("intervalset");
                  }}
                >
                  Add Existing Interval Set
                </ListItemText>
              </MenuItem>
            )}
          </MenuList>
        </Menu>
      </div>
    );
  }
};

export default AddChildInteractionButton;
